import axios from "axios";
import { BASEURL } from "../Config";

export const LOGIN_USER = 'LOGIN_USER';
export const LOGGING_IN_USER = 'LOGGING_IN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
export const ADD_PRODUCTS_TO_CART = 'ADD_PRODUCTS_TO_CART';
export const CLEAR_CART = 'CLEAR_CART';
export const REMOVE_CART_ELEMENT = 'REMOVE_CART_ELEMENT';
export const UPDATE_CART = 'UPDATE_CART';
export const SCHOOL = 'SCHOOL';
export const SET_CLASS_NAME = 'SET_CLASS_NAME';
export const SET_LANGUAGE_NAME = 'SET_LANGUAGE_NAME';
export const SET_CLASS_ID = 'SET_CLASS_ID';
export const SET_LANGUAGE_ID = 'SET_LANGUAGE_ID';
export const SET_ORDER_ID = 'SET_ORDER_ID';
export const SET_PARENT_SCHOOLS = 'SET_PARENT_SCHOOLS';
export const SET_UNIFORM_CATALOG = 'SET_UNIFORM_CATALOG';

export const loginWithData = (userData) => dispatch => {
    dispatch({
        type: LOGIN_USER,
        userData,
        isAuthenticated: true
    });
};

export const loginUser = (email) => dispatch => {
    dispatch({
        type: LOGGING_IN_USER,
        status: true
    })
    let url = `${BASEURL}/api/v1/parent/login`;

    let data = { email: email };
    axios.post(url, data)
        .then(userData => {
            if (userData.status === 200) {
                dispatch({
                    type: LOGIN_USER,
                    userData: userData.data,
                    isAuthenticated: true
                })
                dispatch({
                    type: LOGGING_IN_USER,
                    status: false
                })
            }
            else {
                dispatch({
                    type: LOGGING_IN_USER,
                    status: false
                })
            }
        })
        .catch(err => {
            console.log(err.response.data);
            dispatch({
                type: SET_ERROR_MESSAGE,
                error: err.response.data
            })
            setTimeout(dispatch({
                type: SET_ERROR_MESSAGE,
                error: ""
            }), 5000);
            dispatch({
                type: LOGGING_IN_USER,
                status: false
            })
        })
}

export const logoutUser = () => dispatch => {
    dispatch({
        type: LOGOUT_USER
    })
}

export const setSchool = (school) => dispatch => {
    dispatch({ type: SCHOOL, school });
    if (school && school._id) {
        axios.get(`${BASEURL}/api/v1/uniformProductCatalog/fetch/${school._id}`)
            .then(() => dispatch({ type: SET_UNIFORM_CATALOG, hasUniformCatalog: true }))
            .catch(() => dispatch({ type: SET_UNIFORM_CATALOG, hasUniformCatalog: false }));
    } else {
        dispatch({ type: SET_UNIFORM_CATALOG, hasUniformCatalog: false });
    }
}

export const setClassName = (className) => dispatch => {
    dispatch({
        type: SET_CLASS_NAME,
        className: className
    })
}

export const setLanguageName = (lname) => dispatch => {
    dispatch({
        type: SET_LANGUAGE_NAME,
        lname: lname
    })
}

export const setClassId = (classId) => dispatch => {
    dispatch({
        type: SET_CLASS_ID,
        classId: classId
    })
}

export const setLanguageId = (langId) => dispatch => {
    dispatch({
        type: SET_LANGUAGE_ID,
        langId: langId
    })
}

export const addProductsToCart = (products) => (dispatch) => {
    dispatch({
        type: ADD_PRODUCTS_TO_CART,
        products
    })
}

export const clearCart = () => (dispatch) => {
    dispatch({
        type: CLEAR_CART,
    })
}

export const updateCart = (products) => (dispatch) => {
    dispatch({
        type: UPDATE_CART,
        products
    })
}


export const setSelectedOrderId = (orderId) => (dispatch) => {
    dispatch({
        type: SET_ORDER_ID,
        setSelectedOrderId: orderId
    })
}

export const setParentSchools = (schools) => (dispatch) => {
    dispatch({
        type: SET_PARENT_SCHOOLS,
        schools
    })
}